"use strict";

import {on, findIn, addClass, removeClass} from "@elements/dom-utils";
import {onFind} from "@elements/init-modules-in-scope";

export function init () {

    onFind('.js-show-password', function (baseElement) {
        let showIcon = findIn('.js-show-password-icon--show', baseElement);
        let hideIcon = findIn('.js-show-password-icon--hide', baseElement);
        let input = findIn('.js-show-password__input', baseElement);
        on('click', function(){
            input.type = "text";
            removeClass('d-none', hideIcon);
            addClass('d-none', showIcon);
        }, showIcon);

        on('click', function(){
            input.type = "password";
            removeClass('d-none', showIcon);
            addClass('d-none', hideIcon);
        }, hideIcon);
    });
}